import React from 'react';
import { Category } from '@/types';
import { SearchForm } from './search/SearchForm';
import { SearchResultsDialog } from './search/SearchResultsDialog';
import { useSearchLogic } from './search/useSearchLogic';

interface SidebarSearchProps {
  categories: Category[];
}

export function SidebarSearch({ categories }: SidebarSearchProps) {
  const {
    searchAccount,
    setSearchAccount,
    searchTeam,
    setSearchTeam,
    searchProject,
    setSearchProject,
    isOpen,
    setIsOpen,
    searchResults,
    handleSearch,
  } = useSearchLogic(categories);

  return (
    <div className="px-4 py-2 space-y-2 bg-[#1C2536]/50 rounded-lg">
      <SearchForm
        searchAccount={searchAccount}
        setSearchAccount={setSearchAccount}
        searchTeam={searchTeam}
        setSearchTeam={setSearchTeam}
        searchProject={searchProject}
        setSearchProject={setSearchProject}
        onSearch={handleSearch}
      />

      <SearchResultsDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        searchResults={searchResults}
      />
    </div>
  );
}